import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Navbar() {
  useEffect(() => {
    const navLinks = document.querySelectorAll(".nav-link");

    navLinks.forEach((link) => {
      // Add underline span dynamically
      const underline = document.createElement("span");
      underline.className = "underline";
      underline.style.display = "block";
      underline.style.height = "2px";
      underline.style.width = "0";
      underline.style.background = "#001f3f"; 
      underline.style.transition = "0.2s ease";
      link.appendChild(underline);

      // Hover effects
      link.addEventListener("mouseenter", () => {
        underline.style.width = "100%";
        link.style.color = "#001f3f";
      });

      link.addEventListener("mouseleave", () => {
        if (!link.classList.contains("active")) {
          link.style.color = "black";
        }
        underline.style.width = "0";
      });
    });
  }, []);

  const linkStyle = {
    padding: "15px 5px",
    transition: "0.2s",
    color: "black",
    position: "relative",
  };

 const activeLinkStyle = {
  color: "#66b2ff", 
};

  return (
    <nav className="navbar navbar-expand-lg navbar-light fixed-top shadow" style={{ backgroundColor: "#5A7D9A" }}>
      <div className="container">
        <NavLink className="navbar-brand" to="/">
          <img src={logo} alt="Logo" height="60" />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">
            {[
              { path: "/about", label: "Who Are We" },
              { path: "/what-we-do", label: "What We Do" },
              { path: "/projects", label: "Our Creations" },
              { path: "/consult", label: "Consult Us" },
              { path: "/careers", label: "Careers" },
            ].map((item) => (
              <li className="nav-item" key={item.path}>
                <NavLink
                  to={item.path}
                  className="nav-link fw-bold"
                  style={({ isActive }) =>
                    isActive
                      ? { ...linkStyle, ...activeLinkStyle }
                      : linkStyle
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
